module.exports = __webpack_public_path__ + "img/hr-curved-rail-horizontal-right-top-ties.321209e1.png";